/*
* フォームの必須項目検証
* お問い合わせフォーム、個人会員登録フォーム、法人会員登録フォームの必須項目をチェック
*/
export default class FormValidator {
  constructor() {
    this.form = null;
  }

  // DOM要素の初期化
  initialize() {
    this.form = document.querySelector('#recaptcha-form');
    this.setupEventListeners();
  }

  // イベントリスナーの設定
  setupEventListeners() {
    if (this.form) {
      // input, textareaの変更を監視
      this.form.addEventListener('input', () => {
        this.notifyValidationChange();
      });

      // selectボックスの変更も監視
      this.form.addEventListener('change', () => {
        this.notifyValidationChange();
      });
    }
  }

  // 必須フィールドのバリデーション
  validate() {
    // お問い合わせフォームの必須項目をチェック
    if (document.querySelector('#recaptcha-form [name="inquiry[category]"]')) {
      return this.validateInquiryForm();
    }

    // 個人・法人会員登録フォームの必須項目をチェック
    if (document.querySelector('#recaptcha-form [name="customer[email]"]') &&
        document.querySelector('#recaptcha-form [name="customer[password]"]')) {
      return this.validateRegistrationForm();
    }

    // 上記以外（投資家登録確認画面など）：必須フィールドチェックなし
    return true;
  }

  // お問い合わせフォームの検証
  validateInquiryForm() {
    const category = document.querySelector('[name="inquiry[category]"]');
    const name = document.querySelector('[name="inquiry[name]"]');
    const email = document.querySelector('[name="inquiry[email]"]');
    const title = document.querySelector('[name="inquiry[title]"]');
    const content = document.querySelector('[name="inquiry[content]"]');

    return Boolean(
      category?.value && category.value !== '' &&
      name?.value?.trim() &&
      email?.value?.trim() &&
      title?.value?.trim() &&
      content?.value?.trim()
    );
  }

  // 個人・法人会員登録フォームの検証
  validateRegistrationForm() {
    const email = document.querySelector('[name="customer[email]"]');
    const password = document.querySelector('[name="customer[password]"]');
    const passwordConfirmation = document.querySelector('[name="customer[password_confirmation]"]');

    return Boolean(
      email?.value?.trim() &&
      password?.value &&
      passwordConfirmation?.value
    );
  }

  // 検証状態変更の通知
  notifyValidationChange() {
    document.dispatchEvent(new CustomEvent('formValidation:changed'));
  }
}
